import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=2a3dfbed&scoped=true&"
import script from "./BasicInformation.vue?vue&type=script&lang=ts&"
export * from "./BasicInformation.vue?vue&type=script&lang=ts&"
import style0 from "./BasicInformation.vue?vue&type=style&index=0&id=2a3dfbed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3dfbed",
  null
  
)

export default component.exports